export default async function resolveShared(item) {
  const { data, id, playable_id } = item;
  const itemCopy = { ...item, id };
  let {
    duration,
    end_offset,
    original_item,
    start_offset,
    subtitle,
    title
  } = data;

  // Ensure duration is within bounds
  // Duration is in seconds and offsets are in milliseconds
  if (original_item.type === "clip" && original_item.data.audio_file) {
    const audioFileDuration = original_item.data.audio_file.duration;
    if (audioFileDuration < duration) {
      duration = audioFileDuration - start_offset / 1000;
      end_offset = start_offset + duration * 1000;
    }
  } else {
    if (original_item.data.duration < duration) {
      duration = original_item.data.duration - start_offset / 1000;
      // Avoid totally crazy overflows
      duration = duration <= 0 ? original_item.data.duration : duration;
      end_offset = start_offset + duration * 1000;
    }
  }

  if (start_offset >= original_item.data.duration * 1000) {
    start_offset = 0;
  }

  // Check start_offset is before end_offset and remove end_offset if it isn’t
  if (start_offset >= end_offset) {
    end_offset = null;
  }

  return {
    player_item_id: original_item.player_item_id,
    type: original_item.type,
    playable_id,
    id,
    data: {
      ...original_item.data,
      duration,
      end_offset,
      start_offset,
      subtitle,
      title
    },
    _copy: itemCopy
  };
}
